"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Image = _interopRequireDefault(require("../../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var ProductIntroduction = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var style = props.style,
    configuration = props.configuration,
    flexTitle = props.flexTitle;
  return /*#__PURE__*/_react["default"].createElement("section", {
    ref: ref,
    className: 'flex-default-production-introduction-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-production-introduction-container__children'
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var _a = item || {},
      imageUrl = _a.imageUrl,
      article = _a.article,
      imageBgTextHref = _a.imageBgTextHref,
      imageBgText = _a.imageBgText,
      filedVideoBg = _a.filedVideoBg,
      filedVideoList = _a.filedVideoList,
      extendProps1 = _a.extendProps1;
    var imageTextStatus = !filedVideoList && imageBgTextHref && imageBgText;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: 'f-d-p-i-c__c__content'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'f-d-p-i-c__c__content__left'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'f-d-p-i-c__c__title'
    }, flexTitle), /*#__PURE__*/_react["default"].createElement("article", {
      dangerouslySetInnerHTML: {
        __html: article || ''
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'f-d-p-i-c__c__content__right'
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      width: 368,
      height: 207,
      filedVideoBg: filedVideoBg,
      filedVideoList: filedVideoList,
      source: imageUrl || 'https://staticintl.cloudcachetci.com/cms/backend-cms/video.MP4',
      record: item
    }), imageTextStatus ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: 'f-d-p-i-c__c__content__right__img--text'
    }, /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: imageBgTextHref
    }, extendProps1 || {}), imageBgText, /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.00015 0.292908L0.585937 1.70712L4.87883 6.00001L0.585937 10.2929L2.00015 11.7071L7.70726 6.00001L2.00015 0.292908Z",
      fill: "white"
    }))))) : null));
  })));
});
var _default = exports["default"] = ProductIntroduction;